import { vObject, type vOutput, vString } from '../validation/index.ts'

export const verifyTokenSchema = vObject({
  token: vString(),
})
export type VerifyTokenDto = vOutput<typeof verifyTokenSchema>

export interface VerifyTokenResponse {
  success: boolean
}
